<template>
  <panel class="margins">
    <div class="header-wrapper">
      <div class="header">
        <icon class="icon" :glyph="icon" />
        <h3>{{ title }}</h3>
      </div>
      <div v-if="buttonTitle" class="header">
        <el-button type="primary" size="mini" @click="onClick">
          {{ buttonTitle }}
        </el-button>
      </div>
    </div>
    <slot name="metrics"></slot>
  </panel>
</template>

<script>
import Panel from '@/common/components/Panel'
export default {
  name: 'ChannelMetrics',
  components: { Panel },
  props: {
    buttonTitle: {
      type: String,
      required: false
    },
    buttonAction: {
      method: {
        type: Function,
        required: false,
        default: () => {}
      }
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  },
  methods: {
    onClick() {
      this.buttonAction()
    }
  }
}
</script>

<style scoped>
.header-wrapper {
  display: flex;
  justify-content: space-between;
}
.header {
  display: flex;
  align-items: center;
  padding-bottom: 24px;
}
h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #1d87c8;
  display: inline-block;
}

.icon {
  color: #1d87c8;
  width: 32px;
  height: 32px;
  margin-right: 18px;
  margin-left: 2px;
}

>>> .el-row {
  padding-bottom: 24px;
  margin: 0 !important;
}

>>> .el-col {
  padding: 0 48px 0 0 !important;
}

>>> .el-card__body {
  padding-bottom: 0;
  padding-right: 24px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/ChannelMetrics.vue